
    <div class="w-full bg-white px-4 md:px-8">
        <!-- Header -->
        <div class="flex flex-row  justify-between items-center py-3 border-b">

            <!-- Title -->
            <div class="w-full flex items-center">
                <arrow-back></arrow-back>
                <div>
                    <div 
                        class="text-2xl font-extrabold leading-7 tracking-tight sm:leading-10 md:text-4xl"
                        >Listado General de Atributos de Bien Cultural
                    </div>
                    <div class="ml-0.5 font-medium text-secondary"></div>
                </div>
            </div>
            
        </div>

        <div class="mt-4 md:mt-8">
            <div>
                <span class="font-normal">Utilice este listado de atributos para personalizar las plantillas de Documentos Oficiales</span>
            </div>
            <mat-form-field
                    *hasPermissions="'buscador_atributos_bien_cultural'; modulos ['Atributos']"
                    class="fuse-mat-dense w-full mt-4"
                >
                    <mat-icon
                        class="absolute ml-6 sm:ml-8"
                        [svgIcon]="'heroicons_outline:magnifying-glass'"
                    ></mat-icon>
                    <input matInput
                        class="h-full w-full px-16 sm:px-18"
                        [formControl]="searchControl"
                        [placeholder]="'Buscar...'"
                        #barSearchInput
                    />
            </mat-form-field>

            <div class="bg-card rounded-2xl shadow p-4 overflow-y-auto overflow-x-auto">
                <table
                    class="w-full bg-transparent mb-2"
                    mat-table
                    matSort
                    [dataSource]="dataSource"
                    #bienes>

                    <!-- Numero-->
                    <ng-container matColumnDef="numero">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                            Número
                        </th>
                        <td mat-cell *matCellDef="let atributo;  let i = index">
                            {{ i + 1 + (paginator.pageIndex * pageSize) }}
                        </td>
                    </ng-container>

                    <!-- nombre-del-campo -->
                    <ng-container matColumnDef="nombre-del-campo">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="whitespace-nowrap text-sm py-1">
                            Nombre del Campo
                        </th>
                        <td mat-cell *matCellDef="let atributo">
                            <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                                {{atributo.campoNombre}}
                            </span>
                        </td>
                    </ng-container>

                    <!-- uso -->
                    <ng-container matColumnDef="uso">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                            Uso
                        </th>
                        <td mat-cell *matCellDef="let atributo">
                            <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                            {{atributo.aplicacion}}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Descripción -->
                    <ng-container matColumnDef="descripcion">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                            Descripción
                        </th>
                        <td mat-cell *matCellDef="let atributo">
                            <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                               {{atributo.descripcion}} 
                            </span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="atributosTableColumns" class="bg-slate-100 h-12"></tr>
                    <tr class="text-gray-600 order-row h-10 border-y border-gray-200 cursor-pointer hover:text-black"
                    mat-row *matRowDef="let row; columns: atributosTableColumns;"></tr>
                </table>
                <mat-paginator [length]="totalResultItems" [pageSize]="this.pageSize" [hidePageSize]="true"></mat-paginator>
            </div> 
        </div>

    </div>
